




























import { computed, defineComponent, PropType, reactive, ref } from '@nuxtjs/composition-api'

import useFilterBarItem from '@/composables/use-filter-bar-item'

import CustomSelectItem from '@/interfaces/CustomSelectItem'
import { tdCarFilterPc } from '@/modules/ga4'

export default defineComponent({
  props: {
    carTypes: {
      type: Array as PropType<unknown[] | null>,
      default: null,
    },
    priceRange: {
      type: Array as unknown as PropType<[number, number]>,
      default: () => [0, Infinity],
    },
    priceRangeMinMax: {
      type: Array as PropType<unknown[] | null>,
      default: null,
    },
    storeServices: {
      type: Array as PropType<unknown[] | null>,
      default: null,
    },
    equipments: {
      type: Array as PropType<unknown[] | null>,
      default: null,
    },
    active: {
      type: Boolean,
      default: false,
    },
    availableCarTypes: {
      type: Array as PropType<CustomSelectItem['value'][]>,
      default: () => [],
    },
  },
  setup (props, { emit }) {
    const proxyCarTypes = computed({
      get: () => props.carTypes,
      set: value => emit('update:carTypes', value),
    })

    const proxyPriceRange = computed({
      get: () => props.priceRange,
      set: value => emit('update:priceRange', value),
    })

    const proxyStoreServices = computed({
      get: () => props.storeServices,
      set: value => emit('update:storeServices', value),
    })

    const proxyEquipments = computed({
      get: () => props.equipments,
      set: value => emit('update:equipments', value),
    })

    const {
      options,
      isShow,
      show,
      hide,
      saveAndHide,
      proxyValue,
      save,
    } = useFilterBarItem(ref(), emit)

    const clickSave = () => {
      saveAndHide()

      tdCarFilterPc({
        model: selected.model.map(item => item.name).join(','),
        price_min: selected.price[0].toString(),
        price_max: selected.price[1].toString(),
        optional: selected.storeService.map(item => item.name).join(','),
        equipment: selected.equipment.map(item => item.name).join(','),
      })
    }

    const clear = () => {
      emit('update:carTypes')
      emit('update:priceRange')
      emit('update:storeServices')
      emit('update:equipments')
    }

    const selected = reactive({
      model: [] as CustomSelectItem[],
      price: [] as number[],
      storeService: [] as CustomSelectItem[],
      equipment: [] as CustomSelectItem[],
    })
    const onUpdate = (key: keyof typeof selected, value: any) => {
      selected[key] = value
    }

    return {
      ...useFilterBarItem(ref(), emit),
      proxyCarTypes,
      proxyPriceRange,
      proxyStoreServices,
      proxyEquipments,
      clear,
      options,
      isShow,
      show,
      hide,
      saveAndHide,
      proxyValue,
      save,
      clickSave,

      selected,
      onUpdate,
    }
  },
})
